;(function() {
/* @ngInject */
function RoundUpDonationController(Helpers, $filter, $scope) {
    let vm = this;

    vm.items = [];

    vm.model = {};

    vm.custom = null;

    vm.onElementFocus = Helpers.onElementFocus;
    vm.onCustomChange = onCustomChange;

    $scope.$watch('vm.price', function () {
        getItems();
    }, true);

    $scope.$watch('vm.model', function () {
        onCustomChange();
    }, true);

    function onCustomChange() {
        if(vm.model.type === -1) {
            if(angular.isNumber(vm.custom))
                vm.donation = vm.custom;
            else vm.donation = 0;
        } else {
            vm.donation = vm.model.type;
        }
    }

    function getItems() {
        vm.items = [];
        let roundedPrice = Math.ceil(vm.price);
        let firstRoundedPrice = roundedPrice;

        let roundUpAmount = parseFloat((roundedPrice - vm.price).toFixed(2));
        let firstRoundUpAmount = roundUpAmount;

        if(roundUpAmount === 0) {
            firstRoundUpAmount = 0.5;
            firstRoundedPrice = roundedPrice + 0.5;
        }

        vm.items.push({value: 0, name: $filter("translate")("roundUpDonation.without")});
        vm.items.push({value: firstRoundUpAmount, name: $filter("translate")("roundUpDonation.with", {fullPrice: firstRoundedPrice, donation: (firstRoundUpAmount).toFixed(2)})});
        vm.items.push({value: roundUpAmount + 1, name: $filter("translate")("roundUpDonation.with", {fullPrice: +roundedPrice + 1, donation: (+roundUpAmount + 1).toFixed(2)})});
        vm.items.push({value: roundUpAmount + 2, name: $filter("translate")("roundUpDonation.with", {fullPrice: +roundedPrice + 2, donation: (+roundUpAmount + 2).toFixed(2)})});
        vm.items.push({value: roundUpAmount + 5, name: $filter("translate")("roundUpDonation.with", {fullPrice: +roundedPrice + 5, donation: (+roundUpAmount + 5).toFixed(2)})});
        vm.items.push({value: -1, name: $filter("translate")("roundUpDonation.custom")});

        if(vm.donation === 0) {
            vm.model = {
                type: vm.items[0].value,
                name: vm.items[0].name
            }
        } else {
            let obj = vm.items.find(i => i.value === vm.donation);

            if(obj && Object.keys(obj).length > 0) {
                vm.model.type = obj.value;
                vm.model.name = obj.name;
            } else {
                vm.model.type = -1;
                vm.model.name = vm.items[vm.items.length - 1].name;

                if(vm.custom === null && vm.donation > 0) {
                    vm.custom = vm.donation;
                }
            }
        }
    }
}

angular.module("firmaren")
    .component("roundUpDonation", {
        templateUrl: "/app/shared/round-up-donation/round-up-donation.html",
        controller: RoundUpDonationController,
        controllerAs: "vm",
        bindings: {
            price: "=",
            donation: "="
        }
    });
}());
